import { ListViewData } from '@y42/core/list-view';
import {
  AbstractFeatureEntityState,
  AbstractFeatureStoreModel,
  AbstractFeatureUIModel,
  UserRelatedData,
} from '@y42/feature';
import { getJSONSchemaURL, Y42MetadataGitModel } from '@y42/feature/json-schema';
import { StatusAlertSettings } from '@y42/json-schema';

export class StatusAlertSettingsGitModel extends StatusAlertSettings {
  constructor(model: StatusAlertStoreModel) {
    super();
    const settings = model.settings;
    this.$schema = getJSONSchemaURL('status-alert-settings');
    this.feature_type = settings.feature_type;
    this.alert_on = settings.alert_on;
    this.triggered_by = settings.triggered_by;
    this.title = settings.title;
    this.message_body = settings.message_body;
    this.patterns = settings.patterns;
    this.tags = settings.tags;
    this.destinations = settings.destinations;
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class StatusAlertStoreModel extends Y42MetadataGitModel implements AbstractFeatureStoreModel {
  constructor(model: StatusAlertStoreModel) {
    super(model);
    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;
    this.settings = model.settings;
    this.icon = model.icon;
  }

  $name: string;
  $path: string;
  $level: number;

  icon?: string;

  settings: StatusAlertSettingsGitModel;
}

export type StatusAlertUIModel = AbstractFeatureUIModel &
  StatusAlertStoreModel &
  Partial<UserRelatedData> & {
    // placeholder for additional UI properties
  };

export type StatusAlertListViewData = ListViewData<StatusAlertUIModel> & {
  // placeholder for additional list-view properties
};

export type StatusAlertState = AbstractFeatureEntityState<StatusAlertStoreModel>;
